<template>
  <PageLayout>
    <!-- Standalone web page: framed by the web-page host adapter (RevDialog
         confirmations, close() navigates home instead of dismissing a webview). -->
    <WebPageShoppingAssistantHost
      :can-resume-latest
      :entry-point
      :initial-chat-id
      :is-seeded-launch
      :page-context
      :seeded-message
    />
  </PageLayout>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'
import { computed } from 'vue'

import PageLayout from '../../components/PageLayout/PageLayout.vue'
import { useShoppingAssistantContext } from '../../composables/useShoppingAssistantContext'
import { SHOPPING_ASSISTANT_NEW } from '../../routes.constants'

import WebPageShoppingAssistantHost from './components/WebPageShoppingAssistantHost.vue'

const route = useRoute()

// The explicit "new chat" route always starts fresh — never resume the latest
// chat there, even though it carries no chatId and no seed (a route change
// between route records always remounts this component, so this is stable per
// mount).
const canResumeLatest = computed(() => route.name !== SHOPPING_ASSISTANT_NEW)

// The web page derives the chat context from the route (deep-link query
// params, chatId path param) and frames the route-agnostic chat core.
const { pageContext, entryPoint, seededMessage, isSeededLaunch } =
  useShoppingAssistantContext()

const initialChatId =
  typeof route.params.chatId === 'string' ? route.params.chatId : null
</script>
